import Modal from "react-modal";
import Icon from '../Icon/Icon';
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import SystemContext from "@contexts/system-context";
import { logout } from "../../functions/auth";
import { useCookies } from "react-cookie";

const VersionModal = () => {
    const { t } = useTranslation('common');
    const [ open, setOpen ] = useState<boolean>(false);
    const [ hasOpen, setHasOpen ] = useState<boolean>(false);
    const { systemVersion } = useContext(SystemContext);
    const [ cookie, setCookie, removeCookie ] = useCookies([ 'authToken', 'refreshToken', 'user']);

    useEffect(() => {
        if(!systemVersion) return;
        // eslint-disable-next-line no-debugger
        // debugger;
        const storageVersion = sessionStorage.getItem("version");

        console.group("Version");
        console.debug("Storage version", storageVersion);
        console.debug("System API version", systemVersion);
        console.groupEnd();

        setOpen(storageVersion !== systemVersion);
    }, [ systemVersion ]);

    // Check if the modal has been displayed to the user
    useEffect(() => {
        if(!open) return;
        setHasOpen(true);
    }, [ open ]);

    useEffect(() => {
        if(open) return;
        if(!hasOpen) return;

        const clearCookiesFn = () => {
            removeCookie("authToken");
            removeCookie("refreshToken");
            removeCookie("user");
        };

        // Close session
        logout(clearCookiesFn);
    }, [ open, hasOpen, removeCookie ]);

    return (
        <Modal isOpen={ open }>
            <p className="SectionLabel">{t('common:version.newVersionAlert', { version: systemVersion })}</p>
            <div className="ReactModal__ButtonClose">
                <button onClick={ () => setOpen(false) } >
                    <Icon name='FaTimes' />
                </button>
            </div>
            <div className="HorizontalFlex" style={{display:"flex", justifyContent:"center"}}>
                <div className="ButtonComponent" style={{width:"50%"}}>
                    <button 
                        onClick={ () => setOpen(false) } 
                        type="button" 
                        className="ButtonContainer">
                        <span className="ButtonText">{t('common:buttons.accept')}</span>
                    </button>
                </div>
            </div>

        </Modal>
    );
};

export default VersionModal;
